import * as tempMessageApi from '../../api/temp-message-api';
import { IResult } from '../../models/result-models';
import { ITempMessage } from '../../models/temp-message';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_TEMP_MESSAGES_SUCCESS = 'LOAD_TEMP_MESSAGES_SUCCESS';
export const LOAD_TEMP_MESSAGES_ERROR = 'LOAD_TEMP_MESSAGES_ERROR';

// Actions
export const loadTempMessagesSuccess = (payload: IResult<ITempMessage[]>) => ({
    type: LOAD_TEMP_MESSAGES_SUCCESS,
    payload,
});

export const loadTempMessagesError = (payload: IResult<ITempMessage[]>) => ({
    type: LOAD_TEMP_MESSAGES_ERROR,
    payload,
});

// Thunks
export const loadTempMessages = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await tempMessageApi.getTempMessages();
            if (result.ok) {
                dispatch(loadTempMessagesSuccess(result));
            } else {
                dispatch(
                    apiCallError({
                        name: '',
                        message: 'error getting temp messages',
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
